import {MaterialsShare} from './MaterialsShare';
export default MaterialsShare;
